module.exports = __webpack_public_path__ + "static/media/IK BUBBLE.9a7fd8b6.png";